import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import apiClient from '../../utils/apiClient'
import ebrLogo from '../../assets/icons/ebrLogo.svg'
import rCircle from '../../assets/icons/rCircle.svg'
import './LoginPage.css'
import ConfirmationModal from '../../components/UI/ConfirmationModal'
import {
  countryOptions,
  extractCountryCode,
  validatePhoneNumber,
  getMaskedNumber
} from '../../utils/phoneUtils'

const LoginPage = () => {
  const navigate = useNavigate()
  const [countryLabel, setCountryLabel] = useState(countryOptions[0].label)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [consentChecked, setConsentChecked] = useState(false)
  const [modalMessage, setModalMessage] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleLoginSubmit = async e => {
    e.preventDefault()
    if (!consentChecked) {
      setModalMessage('Please agree to the SMS terms by checking the box before logging in')
      setIsModalOpen(true)
      return
    }
    setIsLoading(true)
    const validationError = validatePhoneNumber(countryLabel, phoneNumber)
    if (validationError) {
      setModalMessage(validationError)
      setIsModalOpen(true)
      setIsLoading(false)
      return
    }
    try {
      const digits = phoneNumber.replace(/\D/g, '')
      const cc = extractCountryCode(countryLabel)
      const fullPhone = `${cc}${digits}`
      const signInResponse = await apiClient.post('/auth/admin_signin', {
        PhoneNumber: fullPhone
      })
      if (signInResponse.data) {
        navigate('/otp', {
          state: {
            phone: getMaskedNumber(fullPhone),
            phoneNumber: fullPhone,
            session: signInResponse.data
          }
        })
      } else {
        throw new Error('No session received from sign-in endpoint')
      }
    } catch (err) {
      console.error('Login error:', err)
      setModalMessage(err.response?.data || 'Server error. Please try again later.')
      setIsModalOpen(true)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="login-page-container">
      <div className="login-page-left">
        <div className="ebr-logo-container">
          <img src={ebrLogo} alt="Eberhard Logo" className="ebr-logo" />
        </div>
        <h2 className="login-hero-title">Pro Tip:</h2>
        <h1 className="login-hero-heading">
          Control the entire fleet with the admin solution
        </h1>
        <p className="login-hero-sub">
          Your team's central source of truth from local development to production...
        </p>
      </div>
      <div className="login-page-right">
        <div className="login-tabs">
          <button className="login-tab active">Log In</button>
        </div>
        <form className="login-form" onSubmit={handleLoginSubmit}>
          <label className="login-label">
            Country/Region
            <select
              className="login-select"
              value={countryLabel}
              onChange={e => setCountryLabel(e.target.value)}
            >
              {countryOptions.map(o => (
                <option key={o.code + o.label} value={o.label}>
                  {o.label}
                </option>
              ))}
            </select>
          </label>
          <label className="login-label">
            Phone number
            <input
              className="login-input"
              type="tel"
              placeholder="Phone number"
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
              required
            />
          </label>
          <div className="login-consent-container">
            <label className="login-consent">
              <input
                type="checkbox"
                checked={consentChecked}
                onChange={e => setConsentChecked(e.target.checked)}
              />
              <span className="login-small-text">
                By checking this box, you agree to receive text messages (SMS) from Eberhard for login authentication. Message frequency varies. Message & data rates may apply. Consent is not a condition of purchase. You can opt out at any time.
              </span>
            </label>
          </div>
          <button
            className="login-button"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? 'Please wait...' : 'Log In →'}
          </button>
        </form>
        <ConfirmationModal
          isOpen={isModalOpen}
          onConfirm={() => setIsModalOpen(false)}
          message={modalMessage}
          confirmLabel="OK"
          showCancel={false}
        />
      </div>
    </div>
  )
}

export default LoginPage
